module.exports = "/_next/static/images/guanyuwomen-cae59eaac8429acaf50b30a59f253e11.png";